module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [_vm._l((_vm.navItems), function(nav, index) {
    return _c('div', {
      key: nav.name,
      staticClass: "small-div"
    }, [_c('a', {
      staticClass: "div-link",
      attrs: {
        "href": nav.path
      }
    }, [_vm._v("\n          " + _vm._s(nav.label) + "\n        ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "small-div white"
  }, [_c('div', [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/logo-text.svg")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.phone && _vm.fax) ? _c('div', {
    staticClass: "font-bold",
    staticStyle: {
      "padding": "0",
      "margin-top": "20px",
      "font-size": "1.2em"
    }
  }, [_vm._v("\n            Call: " + _vm._s(_vm.phone) + "   Fax: " + _vm._s(_vm.fax) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.address) ? _c('div', {
    staticStyle: {
      "padding": "0",
      "margin-top": "6px",
      "font-size": "1.2em",
      "font-weight": "normal",
      "line-height": "1.4em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.address) + "\n          ")]) : _vm._e()])])], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1ff346","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarOverlay.vue
// module id = 983
// module chunks = 1